var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "40px 50px" },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "promoterForm",
              staticClass: "demo-promoterForm",
              attrs: {
                model: _vm.promoterForm,
                rules: _vm.rules,
                "label-width": "200px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreSwitch" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("分销启用：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "商城分销功能开启关闭",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.promoterForm.retailStoreSwitch,
                        callback: function ($$v) {
                          _vm.$set(_vm.promoterForm, "retailStoreSwitch", $$v)
                        },
                        expression: "promoterForm.retailStoreSwitch",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreLine" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("满额分销最低金额：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "满额分销满足金额开通分销权限",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      placeholder: "满额分销满足金额开通分销权限",
                      min: -1,
                      step: 1,
                    },
                    nativeOn: {
                      keydown: function ($event) {
                        return _vm.channelInputLimit($event)
                      },
                    },
                    model: {
                      value: _vm.promoterForm.retailStoreLine,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.promoterForm,
                          "retailStoreLine",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "promoterForm.retailStoreLine",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreBindingType" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("分销关系绑定：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "所有用户”指所有没有上级推广人的用户，“新用户”指新注册的用户",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.promoterForm.retailStoreBindingType,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.promoterForm,
                            "retailStoreBindingType",
                            $$v
                          )
                        },
                        expression: "promoterForm.retailStoreBindingType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("所有用户"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("新用户"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreBrokerageFirstRatio" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("一级返佣比例：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "订单交易成功后给上级返佣的比例0 - 100,例:5 = 返订单金额的5%",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      "step-strictly": "",
                      min: 0,
                      max: 100,
                      placeholder:
                        "订单交易成功后给上级返佣的比例0 - 100,例:5 = 返订单金额的5%",
                    },
                    model: {
                      value: _vm.promoterForm.retailStoreBrokerageFirstRatio,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.promoterForm,
                          "retailStoreBrokerageFirstRatio",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "promoterForm.retailStoreBrokerageFirstRatio",
                    },
                  }),
                  _c("span", [_vm._v("%")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreBrokerageSecondRatio" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("二级返佣比例：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "订单交易成功后给上级返佣的比例,例:5 = 返订单金额的5%，返佣比例之和不能大于项目文件配置的佣金返佣比例和上限",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      "step-strictly": "",
                      min: 0,
                      max: 100,
                      placeholder:
                        "订单交易成功后给上级返佣的比例,例:5 = 返订单金额的5%，返佣比例之和不能大于项目文件配置的佣金返佣比例和上限",
                    },
                    model: {
                      value: _vm.promoterForm.retailStoreBrokerageSecondRatio,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.promoterForm,
                          "retailStoreBrokerageSecondRatio",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression:
                        "promoterForm.retailStoreBrokerageSecondRatio",
                    },
                  }),
                  _c("span", [_vm._v("%")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreExtractMinPrice" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("提现最低金额：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "用户提现最低金额",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: { min: 0, step: 1, placeholder: "用户提现最低金额" },
                    model: {
                      value: _vm.promoterForm.retailStoreExtractMinPrice,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.promoterForm,
                          "retailStoreExtractMinPrice",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "promoterForm.retailStoreExtractMinPrice",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreExtractBank" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("提现银行卡：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "提现银行卡，每个银行换行",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c("keyword", {
                    staticStyle: { width: "600px" },
                    attrs: { labelarr: _vm.labelarr, type: _vm.keywordType },
                    on: { getLabelarr: _vm.getLabelarr },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreBrokerageFreezingTime" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("开始冻结规则：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "从哪个状态开始计算冻结时间",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.promoterForm.retailStoreBrokerageShareNode,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.promoterForm,
                            "retailStoreBrokerageShareNode",
                            $$v
                          )
                        },
                        expression:
                          "promoterForm.retailStoreBrokerageShareNode",
                      },
                    },
                    _vm._l(_vm.options, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "retailStoreBrokerageFreezingTime" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("span", [_vm._v("冻结时长：")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "冻结多久进行解冻",
                            placement: "top-start",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-warning-outline" })]
                      ),
                    ],
                    1
                  ),
                  _c("el-input-number", {
                    staticClass: "selWidth",
                    attrs: {
                      min: 0,
                      max: 30,
                      step: 1,
                      "step-strictly": "",
                      placeholder: "佣金冻结时间(天)",
                    },
                    model: {
                      value: _vm.promoterForm.retailStoreBrokerageFreezingTime,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.promoterForm,
                          "retailStoreBrokerageFreezingTime",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression:
                        "promoterForm.retailStoreBrokerageFreezingTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:retail:store:config:save"],
                          expression: "['platform:retail:store:config:save']",
                        },
                      ],
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("promoterForm")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }